import Joi from 'joi'

export const loginSchema = Joi.object({
    username: Joi.string().min(8).required(),
    ID: Joi.string().required(),
})

export const registerSchema = Joi.object({
    Firstname: Joi.string().required(),
    Lastname: Joi.string().required(),
    Email: Joi.string().email({ minDomainSegments: 2, tlds: { allow: ['com', 'net'] } }).required(),
    Username: Joi.string().alphanum().min(6).required(),
    Password: Joi.string().pattern(new RegExp('^[a-zA-Z0-9]{3,30}$')).required(),
    Repeat_password: Joi.ref('Password'),
    Contact: Joi.number().required()
})

export const validateAgent = Joi.object({
    firstname: Joi.string().required(),
    lastname: Joi.string().required(),
    email: Joi.string().email({ minDomainSegments: 2, tlds: { allow: ['com', 'net'] } }).required(),
    username: Joi.string().required(),
    rank: Joi.string().required(),
    password: Joi.string().required(),
    contact: Joi.number()
})

export const updateAgent = Joi.object({
    firstname: Joi.string().required(),
    lastname: Joi.string().required(),
    email: Joi.string().email({ minDomainSegments: 2, tlds: { allow: ['com', 'net'] } }).required(),
    rank: Joi.string().required(),
    contact: Joi.number()
})


export const userUpdateSchema = Joi.object({
    Firstname: Joi.string(),
    Lastname: Joi.string(),
    Email: Joi.string().email({ minDomainSegments: 2, tlds: { allow: ['com', 'net'] } }),
    Username: Joi.string().alphanum().min(6),
    Contact: Joi.number()
})